import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useToasterBehavior } from './useToasterBehavior';

export const Toaster = () => {
  const { state, onChange } = useToasterBehavior();
  const [displayed, setDisplayed] = useState(false);

  useEffect(() => {
    if (state && !displayed) {
      toast(
        <div style={{ display: 'flex' }}>
          <div style={{ marginLeft: '5px' }}>
            <strong>{state.title}</strong>
            <div data-testid="toasterMessage">{state.message}</div>
          </div>
        </div>,
        {
          className: state.className,
          autoClose: 60000,
          position: 'top-right',
          hideProgressBar: false,
          progressStyle: { background: '#ff981a' },
          theme: "light",
          onClose: onChange,
        }
      );
      setDisplayed(true);
    }
  }, [state, onChange, displayed]);

  useEffect(() => {
    if (!state) {
      setDisplayed(false);
    }
  }, [state]);

  return <ToastContainer />;
};
